import { useEffect, useRef } from 'react';

export const useClickOutside = (onClose) => {
  const popUpRef = useRef();
  const buttonRef = useRef();

  useEffect(() => {
    const handleClick = (e) => {
      if (popUpRef.current && !popUpRef.current.contains(e.target)
          && !buttonRef.current?.contains(e.target)) {
        onClose();
      }
    };

    // Use mousedown to capture the event before click
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [onClose]);

  return {popUpRef, buttonRef};
};